<span mat-button mat-dialog-close matTooltip="Close" matTooltipPosition="below" class="close-btn-modal material-icons">close</span>
<h2 style="text-align: center;font-size: 36px;margin: 43px 0;color: #c9dbff;">coming soon</h2>
